/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

type ErrorsList = {
  [key: string]: string;
};

export default (
  errorsList: ErrorsList,
  forValues: Record<string, string | number | boolean>
): boolean => {
  if (!Object.keys(errorsList).length) return false;

  const result = Object.keys(errorsList).every(
    (key) => key in forValues && forValues[key] !== ''
  );

  return result;
};
